import { MonthResponse } from 'core/application/benefit/getAnnualAttestationDetails'

import { Card, Col, Row } from 'common/components'

import CoverageAttestationCalendarButton from './coverageAttestationCalendarButton'

import styles from './index.module.css'

type CoverageAttestationCalendarProps = {
  months: MonthResponse[]
  onClick?: (month: MonthResponse) => void
}

const CoverageAttestationCalendar = ({ months, onClick = () => {} }: CoverageAttestationCalendarProps) => {
  return (
    <Card className={styles.wrap}>
      <h5 className="color-gray-9">Insurance coverage attestation</h5>

      <p className={styles.paragraph}>Click on a previous month to update your ongoing insurance attestation.</p>

      <Row gutter={[4, 4]}>
        {months.map((x) => (
          <Col lg={6} md={8} sm={12} key={x.monthName}>
            <CoverageAttestationCalendarButton month={x} onClick={onClick} />
          </Col>
        ))}
      </Row>
    </Card>
  )
}

export default CoverageAttestationCalendar
